import { useQuery } from "@tanstack/react-query";

import { api } from "./ApiClient";

import { AuthHelper } from "../helpers/auth.helper";

import { IAvailableEntitlementsData } from "../types/misc.interface";
import { IBulkEntitlementsBeneficiaryListItem, IBulkEntitlementsPoolProduct } from "../types/services.interfaces/bulk-entitlements-cax";

export const useGetBulkEntitlementsPool = (source: string, sourceId: number) => {
    AuthHelper.presetPrivateRequest(api);

    const enabled = source === 'client' || (source === 'sub-client' && !!sourceId) || (source === 'cohort' && !!sourceId);

    const queryFn = async (): Promise<IBulkEntitlementsPoolProduct[]> => {
        const res = await api.get(`/bulk-entitlements-cax/pool/${source}/${sourceId}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['bulk-entitlements-pool', source, sourceId],
        queryFn,
        enabled,
    });
};

export const useGetBulkEntitlementsAvailable = (source: string, sourceId: number) => {
    AuthHelper.presetPrivateRequest(api);

    const enabled = source === 'client' || (source === 'sub-client' && !!sourceId) || (source === 'cohort' && !!sourceId);

    const queryFn = async (): Promise<IAvailableEntitlementsData> => {
        const res = await api.get(`/bulk-entitlements-cax/available/${source}/${sourceId}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['bulk-entitlements-available', source, sourceId],
        queryFn,
        enabled,
    });
};

export const useGetBulkEntitlementsBeneficiaries = (source: string, sourceId: number) => {
    AuthHelper.presetPrivateRequest(api);

    const enabled = source === 'client' || (source === 'sub-client' && !!sourceId) || (source === 'cohort' && !!sourceId);

    const queryFn = async (): Promise<IBulkEntitlementsBeneficiaryListItem[]> => {
        const res = await api.get(`/bulk-entitlements-cax/beneficiaries/${source}/${sourceId}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['bulk-entitlements-beneficiaries', source, sourceId],
        queryFn,
        enabled,
    });
};
